// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Estilos globales básicos
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupGlobalErrorHandling } from './utils/errorTracker';
import { Capacitor } from '@capacitor/core';
import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';

// Configurar tracking de errores global
setupGlobalErrorHandling();

// Inicializar servicios nativos si estamos en móvil
if (Capacitor.isNativePlatform()) {
  FirebaseAnalytics.setEnabled({ enabled: true }).catch(err => console.error('Error enabling Analytics:', err));
  FirebaseCrashlytics.setEnabled({ enabled: true }).catch(err => console.error('Error enabling Crashlytics:', err));
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();